import React, { useRef, forwardRef, useState, useCallback, useMemo, useEffect } from 'react';
import ClassNames from "classnames";
import { KEY_VALUES, useControlled, mergeRefs } from '../utils';
var Slider = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    sliderId = props.sliderId,
    _props$tabIndex = props.tabIndex,
    tabindexProp = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    className = props.className,
    style = props.style,
    _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? 100 : _props$max,
    _props$step = props.step,
    step = _props$step === void 0 ? 1 : _props$step,
    range = props.range,
    precision = props.precision,
    valueProp = props.value,
    defaultValue = props.defaultValue,
    hasInterval = props.hasInterval,
    showIntervalTick = props.showIntervalTick,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$valueDesc = props.valueDesc,
    valueDesc = _props$valueDesc === void 0 ? [] : _props$valueDesc,
    _props$showIntervalLa = props.showIntervalLabel,
    showIntervalLabel = _props$showIntervalLa === void 0 ? true : _props$showIntervalLa,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    _props$showRange = props.showRange,
    showRange = _props$showRange === void 0 ? false : _props$showRange,
    onValueChange = props.onValueChange;
  var scale = [];
  var handleValue;
  var currentHandleIndex = 0;
  var track = {
    offset: null,
    length: null
  };
  var trackStyle = {};
  var stepDigits = 0;
  var lastValue;
  var lastWriteValue;
  var dragging = false;
  var touching = false;
  var sliderHandleClick = false;
  var dragListener;
  var touchMoveListener;
  var touchEndListener;
  var mouseupListener;
  var initX;
  var barWidth;
  var startHandleValue;
  var handleValues = [];
  var startx;
  var lastOptionLength;
  var sliderRef = useRef(null);
  var _useControlled = useControlled(valueProp, defaultValue),
    value = _useControlled[0],
    setValue = _useControlled[1];
  var _useState = useState(disabled ? -1 : tabindexProp),
    tabIndex = _useState[0],
    setTabIndex = _useState[1];
  useEffect(function () {
    var _sliderRef$current, _sliderRef$current$qu, _sliderRef$current2;
    /**
     * Adjust the position of slider handle
     */
    var silderBallWidth = ((_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : (_sliderRef$current$qu = _sliderRef$current.querySelector('.ap-slider-handle')) === null || _sliderRef$current$qu === void 0 ? void 0 : _sliderRef$current$qu.getBoundingClientRect().width) || 16;
    var sliderMarkTexts = (_sliderRef$current2 = sliderRef.current) === null || _sliderRef$current2 === void 0 ? void 0 : _sliderRef$current2.querySelectorAll('.ap-slider-mark-text');
    sliderMarkTexts === null || sliderMarkTexts === void 0 ? void 0 : sliderMarkTexts.forEach(function (o, index) {
      if (index === 0 || index === sliderMarkTexts.length - 1) return;
      var sliderTextWidth = o.getBoundingClientRect().width;
      var leftStyle = o.style.left;
      if (sliderTextWidth > silderBallWidth) {
        o.style.left = "calc(" + leftStyle + " - " + (sliderTextWidth - silderBallWidth) / 2 + "px)";
      } else {
        o.style.left = "calc(" + leftStyle + " + " + (silderBallWidth - sliderTextWidth) / 2 + "px)";
      }
    });
    stepDigits = countDecimals(step);
    if (hasInterval && showIntervalLabel) {
      var _sliderRef$current3, _sliderRef$current4, _sliderRef$current4$q, _sliderRef$current5, _sliderRef$current5$q;
      var optionEles = sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current3 = sliderRef.current) === null || _sliderRef$current3 === void 0 ? void 0 : _sliderRef$current3.querySelectorAll('.ap-slider-mark-text');
      var lastOptionEle = optionEles[optionEles.length - 1];
      var railEleRight = sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current4 = sliderRef.current) === null || _sliderRef$current4 === void 0 ? void 0 : (_sliderRef$current4$q = _sliderRef$current4.querySelector('.ap-slider-rail')) === null || _sliderRef$current4$q === void 0 ? void 0 : _sliderRef$current4$q.getBoundingClientRect().right;
      var markEleWidth = sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current5 = sliderRef.current) === null || _sliderRef$current5 === void 0 ? void 0 : (_sliderRef$current5$q = _sliderRef$current5.querySelector('.ap-slider-mark')) === null || _sliderRef$current5$q === void 0 ? void 0 : _sliderRef$current5$q.getBoundingClientRect().width;
      // lastOptionLength = `calc(100% - ${Math.ceil(lastOptionEle.getBoundingClientRect().right + markEleWidth! - railEleRight!)}px)`;
      lastOptionLength = "calc(100% - " + (Math.ceil(lastOptionEle.getBoundingClientRect().width) - 16) + "px)";
      lastOptionEle.style.left = lastOptionLength;
    }
    if (hasInterval && showIntervalTick) {
      var _sliderRef$current6;
      var sliderTickEles = sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current6 = sliderRef.current) === null || _sliderRef$current6 === void 0 ? void 0 : _sliderRef$current6.querySelectorAll('.ap-slider-mark-tick');
      sliderTickEles.forEach(function (o, p) {
        var tickWidth = o.getBoundingClientRect().width;
        if (p === 0) {
          o.style.left = '0';
        } else if (p === sliderTickEles.length - 1) {
          o.style.left = '100%';
        } else {
          o.style.left = "calc(" + p / (sliderTickEles.length - 1) * 100 + "%";
        }
        o.style.top = "-" + (tickWidth - 2) / 2 + "px";
      });
    }
    return function () {
      document.removeEventListener('mousemove', mousemoveEvent);
      document.removeEventListener('mouseup', mousEvent);
      document.removeEventListener('touchmove', touchmoveEvent);
      document.removeEventListener('touchend', touchendEvent);
    };
  }, []);
  var countDecimals = function countDecimals(num) {
    if (Math.floor(num) === num) return 0;
    return num.toString().split(".")[1].length || 0;
  };
  var handles = useMemo(function () {
    var amount = range ? 2 : 1;
    return Array(amount).fill(0).map(function () {
      return {
        offset: null,
        value: null,
        active: false
      };
    });
  }, [range]);
  var resetInterval = function resetInterval() {
    if (hasInterval) {
      if (!min && min !== 0 || !max || !step) return;
      scale = [];
      for (var _i = min; _i <= max; _i += step) {
        scale.push(_i);
      }
      handleValue = scale.findIndex(function (el) {
        return el === value;
      }) / (scale.length - 1) * 100;
      if (handleValue === -100) {
        handleValue = 0;
        setValue(scale[0]);
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(scale[0]);
      }
    }
  };
  var isValueRange = function isValueRange(value) {
    if (value instanceof Array) {
      return value.length === 2;
    } else {
      return false;
    }
  };
  var getDecimalsCount = function getDecimalsCount(value) {
    if (value && Math.floor(value) !== value) {
      return value.toString().split(".")[1].length || 0;
    }
    if (value && precision && precision > 0) {
      return precision;
    }
    return 0;
  };
  var getNormalizedValue = function getNormalizedValue(val) {
    var decimalsCount = getDecimalsCount(step);
    if (decimalsCount > 0) {
      return +val.toFixed(decimalsCount);
    } else {
      return Math.floor(val);
    }
  };
  var ensureNumberInRange = function ensureNumberInRange(num, min, max) {
    if (isNaN(num) || num < min) {
      return min;
    } else if (num > max) {
      return max;
    } else {
      return num;
    }
  };
  var formatValue = function formatValue(value) {
    if (!value && value !== 0) {
      return range ? [min, max] : min;
    } else {
      return isValueRange(value) ? value.map(function (val) {
        return ensureNumberInRange(val, min, max);
      }) : ensureNumberInRange(value, min, max);
    }
  };
  var valueToOffset = function valueToOffset(value) {
    return (value - min) / (max - min) * 100;
  };
  var getValueToOffset = function getValueToOffset(value) {
    var normalizedValue = value;
    return isValueRange(normalizedValue) ? normalizedValue.map(function (val) {
      return valueToOffset(val);
    }) : valueToOffset(normalizedValue);
  };
  var getValue = function getValue(cloneAndSort) {
    if (cloneAndSort === void 0) {
      cloneAndSort = false;
    }
    if (cloneAndSort && value && isValueRange(value)) {
      return [].concat(value).sort(function (a, b) {
        return a - b;
      });
    }
    return value;
  };
  var getTrackStyle = useCallback(function () {
    var valueSorted = getValue(true);
    var offsetSorted = getValueToOffset(valueSorted);
    var trackParts = isValueRange(offsetSorted) ? [offsetSorted[0], offsetSorted[1] - offsetSorted[0]] : [0, offsetSorted];
    track.offset = trackParts[0];
    track.length = trackParts[1];
    trackStyle = {
      left: getValidVal(track.offset) + "%",
      width: getValidVal(track.length) + "%"
    };
    return trackStyle;
  }, disabled ? [disabled] : [value, max, min]);
  var updateTrackAndHandles = useCallback(function (isWriteValue) {
    if (isWriteValue === void 0) {
      isWriteValue = false;
    }
    var offset = getValueToOffset(value);
    var valueSorted = getValue(true);
    var offsetSorted = getValueToOffset(valueSorted);
    var trackParts = isValueRange(offsetSorted) ? [offsetSorted[0], offsetSorted[1] - offsetSorted[0]] : [0, offsetSorted];
    track.offset = trackParts[0];
    track.length = trackParts[1];
    handles.forEach(function (handle, index) {
      handle.offset = isValueRange(offset) ? offset[index] : offset;
      handle.value = isValueRange(value) ? value[index] : value || 0;
    });

    // trackStyle = {
    //     left: `${track.offset}%`,
    //     width: `${track.length}%`
    // };

    if (!isWriteValue) {
      var _lastValue;
      var newValueSorted;
      if (valueSorted.length > 0) {
        var value1 = valueSorted[0];
        var value2 = valueSorted[1];
        value1 = Number(value1).toFixed(stepDigits);
        value2 = Number(value2).toFixed(stepDigits);
        if (stepDigits) {
          newValueSorted = [parseFloat(value1), parseFloat(value2)];
        } else {
          newValueSorted = [parseInt(value1), parseInt(value2)];
        }
      } else {
        newValueSorted = valueSorted.toFixed(stepDigits);
        if (stepDigits) {
          newValueSorted = parseFloat(newValueSorted);
        } else {
          newValueSorted = parseInt(newValueSorted);
        }
      }
      if (!lastValue) {
        lastValue = newValueSorted;
        return;
      }
      if (lastValue === newValueSorted || ((_lastValue = lastValue) === null || _lastValue === void 0 ? void 0 : _lastValue.length) > 0 && lastValue[0] === newValueSorted[0] && lastValue[1] === newValueSorted[1]) {
        return;
      }
      lastValue = newValueSorted;
      lastWriteValue = newValueSorted;
    } else {
      var _newValueSorted;
      if (!Array.isArray(valueSorted)) {
        _newValueSorted = Number(valueSorted);
      } else {
        _newValueSorted = [Number(valueSorted[0]), Number(valueSorted[1])];
      }
      lastValue = _newValueSorted;
    }
  }, disabled ? [disabled] : [value, max, min]);
  resetInterval();
  updateTrackAndHandles(true);
  var updateValue = function updateValue(val, event) {
    var nextvalue = formatValue(val);
    if (isValueRange(value)) {
      var newValue = [].concat(value);
      newValue[currentHandleIndex] = nextvalue;
      if (currentHandleIndex === 1 && newValue[1] < newValue[0]) {
        newValue[1] = newValue[0];
      }
      if (currentHandleIndex === 0 && newValue[0] > newValue[1]) {
        newValue[0] = newValue[1];
      }
      setValue(newValue);
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(newValue);
    } else {
      setValue(nextvalue);
      onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(nextvalue);
    }
    updateTrackAndHandles();
  };
  var spin = function spin(event, dir, handleIndex) {
    var step = (props.step || 1) * dir;
    currentHandleIndex = handleIndex;
    var val = isValueRange(value) ? value[currentHandleIndex] : getNormalizedValue(value);
    updateValue(val + step, event);
    event.preventDefault();
  };
  var onHandleKeydown = function onHandleKeydown(event, handleIndex) {
    if (disabled) {
      return;
    }
    if (event.key === KEY_VALUES.UP || event.key === KEY_VALUES.RIGHT) {
      spin(event, 1, handleIndex);
    } else if (event.key === KEY_VALUES.DOWN || event.key === KEY_VALUES.LEFT) {
      spin(event, -1, handleIndex);
    } else if (event.key === KEY_VALUES.END) {
      var val = isValueRange(value) ? value[currentHandleIndex] : getNormalizedValue(value);
      spin(event, max - val, handleIndex);
    } else if (event.key === KEY_VALUES.HOME) {
      var _val = isValueRange(value) ? value[currentHandleIndex] : getNormalizedValue(value);
      spin(event, min - _val, handleIndex);
    }
  };
  var getWindowScrollLeft = function getWindowScrollLeft() {
    var doc = document.documentElement;
    return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  };
  var updateDomData = function updateDomData() {
    var _sliderRef$current7, _sliderRef$current8;
    var rect = (_sliderRef$current7 = sliderRef.current) === null || _sliderRef$current7 === void 0 ? void 0 : _sliderRef$current7.getBoundingClientRect();
    rect && (initX = rect.left + getWindowScrollLeft());
    barWidth = (_sliderRef$current8 = sliderRef.current) === null || _sliderRef$current8 === void 0 ? void 0 : _sliderRef$current8.offsetWidth;
  };
  var calculateHandleValue = function calculateHandleValue(event) {
    if (orientation === "horizontal") {
      var positionX = touching ? event.changedTouches[0].clientX : event.pageX;
      return (positionX - initX) * 100 / barWidth;
    }
  };
  var getValueFromHandle = function getValueFromHandle(handleValue) {
    return (max - min) * (handleValue / 100) + min;
  };
  var setValueFromHandle = function setValueFromHandle(event, handleValue) {
    var value = getValueFromHandle(handleValue);
    value = step === 0 ? value : Math.round((value - min) / step) * step + min;
    updateValue(value, event);
  };
  var handleChange = function handleChange(event) {
    var handleValue = calculateHandleValue(event);
    setValueFromHandle(event, handleValue);
  };
  var mousemoveEvent = function mousemoveEvent(event) {
    if (dragging) {
      handleChange(event);
    }
    event.preventDefault();
  };
  var mousEvent = function mousEvent(event) {
    if (dragging) {
      dragging = false;
    }
    event.preventDefault();
  };
  var bindDragListeners = function bindDragListeners() {
    if (!dragListener) {
      dragListener = document.addEventListener('mousemove', mousemoveEvent);
    }
    if (!mouseupListener) {
      mouseupListener = document.addEventListener('mouseup', mousEvent);
    }
  };
  var touchmoveEvent = function touchmoveEvent(event) {
    if (dragging) {
      handleChange(event);
    }
    event.cancelable && event.preventDefault();
  };
  var touchendEvent = function touchendEvent(event) {
    if (dragging) {
      dragging = false;
    }
    if (touching) {
      touching = false;
    }
    event.cancelable && event.preventDefault();
  };
  var bindTouchListeners = function bindTouchListeners() {
    if (!touchMoveListener) {
      touchMoveListener = document.addEventListener('touchmove', touchmoveEvent);
    }
    if (!touchEndListener) {
      touchEndListener = document.addEventListener('touchend', touchendEvent);
    }
  };
  var _onMouseDown = function onMouseDown(event, index) {
    if (disabled) {
      return;
    }
    dragging = true;
    updateDomData();
    sliderHandleClick = true;
    currentHandleIndex = index;
    if (range) {
      var _sliderRef$current9, _sliderRef$current9$q;
      (_sliderRef$current9 = sliderRef.current) === null || _sliderRef$current9 === void 0 ? void 0 : (_sliderRef$current9$q = _sliderRef$current9.querySelectorAll('.ap-slider-handle')) === null || _sliderRef$current9$q === void 0 ? void 0 : _sliderRef$current9$q.forEach(function (o, p) {
        if (p === index) {
          o.style.zIndex = 1;
        } else {
          o.style.zIndex = 0;
        }
      });
    }
    bindDragListeners();
    event.target.focus();
    event.preventDefault();
  };
  var _onTouchStart = function onTouchStart(event, index) {
    if (disabled) {
      return;
    }
    dragging = true;
    touching = true;
    updateDomData();
    sliderHandleClick = true;
    currentHandleIndex = index;
    if (range) {
      var _sliderRef$current10, _sliderRef$current10$;
      (_sliderRef$current10 = sliderRef.current) === null || _sliderRef$current10 === void 0 ? void 0 : (_sliderRef$current10$ = _sliderRef$current10.querySelectorAll('.ap-slider-handle')) === null || _sliderRef$current10$ === void 0 ? void 0 : _sliderRef$current10$.forEach(function (o, p) {
        if (p === index) {
          o.style.zIndex = 1;
        } else {
          o.style.zIndex = 0;
        }
      });
    }
    bindTouchListeners();
    event.target.focus();
    event.cancelable && event.preventDefault();

    // var touchobj = event.changedTouches[0];
    // startHandleValue = range
    //     ? handleValues[index]
    //     : handleValue;
    // dragging = true;
    // currentHandleIndex = index;
    // if (orientation === "horizontal") {
    //     startx = parseInt(touchobj.clientX, 10);
    //     barWidth = sliderRef.current?.offsetWidth;
    // }

    // event.cancelable && event.preventDefault();
  };

  var onTouchMove = function onTouchMove(event, index) {
    if (disabled) {
      return;
    }
    var touchobj = event.changedTouches[0],
      handleValue = 0;
    if (orientation === "horizontal") {
      handleValue = Math.floor((parseInt(touchobj.clientX, 10) - startx) * 100 / barWidth) + startHandleValue;
    }
    setValueFromHandle(event, handleValue);
    event.preventDefault();
  };
  var onTouchEnd = function onTouchEnd(event, index) {
    if (disabled) {
      return;
    }
    dragging = false;
    event.preventDefault();
  };
  var getValidVal = function getValidVal(val) {
    if (!val) return 0;
    return val > 100 ? 100 : val < 0 ? 0 : val;
  };
  var setSliderHandleStyle = function setSliderHandleStyle(handle) {
    var leftStyle = '0';
    if (hasInterval && showIntervalTick) {
      var _sliderRef$current11, _sliderRef$current11$, _sliderRef$current12;
      var sliderTickWidth = ((_sliderRef$current11 = sliderRef.current) === null || _sliderRef$current11 === void 0 ? void 0 : (_sliderRef$current11$ = _sliderRef$current11.querySelector('.ap-slider-mark-tick')) === null || _sliderRef$current11$ === void 0 ? void 0 : _sliderRef$current11$.getBoundingClientRect().width) || 0;
      var handleWidth = ((_sliderRef$current12 = sliderRef.current) === null || _sliderRef$current12 === void 0 ? void 0 : _sliderRef$current12.querySelectorAll('.ap-slider-handle')[0].getBoundingClientRect().width) || 0;
      leftStyle = "calc(" + getValidVal(handle.offset) + "% - " + (handleWidth - sliderTickWidth) / 2 + "px)";
    } else {
      leftStyle = getValidVal(handle.offset) + "%";
    }
    return leftStyle;
  };
  var onBarClick = function onBarClick(event) {
    if (disabled) {
      return;
    }
    if (!sliderHandleClick) {
      updateDomData();
      handleChange(event);
    }
    sliderHandleClick = false;
  };
  var classSliderNames = ClassNames("ap-slider ap-slider-horizontal", className, {
    "has-interval": hasInterval && showIntervalLabel,
    "disabled": disabled
  });
  var isActive = function isActive(option) {
    return hasInterval && value != undefined && value != null ? value >= option : false;
  };
  var renderSliderMarkTick = function renderSliderMarkTick() {
    var results = [];
    scale.forEach(function (item, index) {
      var classSliderMarkTickNames = ClassNames("ap-slider-mark-tick", {
        "active": isActive(item)
      });
      var sliderMarkTickStyle = {
        left: '0'
      };
      results.push( /*#__PURE__*/React.createElement("span", {
        key: index,
        className: classSliderMarkTickNames,
        style: sliderMarkTickStyle
      }));
    });
    return results;
  };
  var renderSliderHandles = function renderSliderHandles() {
    var results = [];
    handles.forEach(function (handle, index) {
      var ariaLabel;
      if (valueDesc && valueDesc.length > 0) {
        ariaLabel = '';
      } else {
        ariaLabel = range ? index === 0 ? 'minimum of value of ' + sliderId : 'maximum of value of ' + sliderId : sliderId;
      }
      var ariaLabelRange = "The minimum value is " + min + ", the maximum value is " + max;
      results.push( /*#__PURE__*/React.createElement("span", {
        key: index
      }, /*#__PURE__*/React.createElement("span", {
        role: "slider",
        tabIndex: tabIndex,
        "aria-label": ariaLabel,
        "aria-labelledby": "ariaLabelForSlider" + index,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": handle.value,
        "aria-valuetext": valueDesc[handle.value - 1] || handle.value,
        "aria-disabled": disabled,
        onKeyDown: function onKeyDown(e) {
          onHandleKeydown(e, index);
        },
        onMouseDown: function onMouseDown(e) {
          _onMouseDown(e, index);
        },
        onTouchStart: function onTouchStart(e) {
          _onTouchStart(e, index);
        },
        className: "ap-slider-handle ap-slider-handle-" + (index === 0 ? 'first' : 'last'),
        style: {
          left: setSliderHandleStyle(handle)
        }
      }), /*#__PURE__*/React.createElement("span", {
        id: "ariaLabelForSlider" + index,
        style: {
          display: 'none'
        }
      }, showRange ? ariaLabel + ". " + ariaLabelRange : ariaLabel)));
    });
    return results;
  };
  var renderSliderMarkText = function renderSliderMarkText() {
    var results = [];
    scale.forEach(function (item, index) {
      var classSliderMarkTextNames = ClassNames("ap-slider-mark-text", {
        "active": isActive(item)
      });
      results.push( /*#__PURE__*/React.createElement("span", {
        key: index,
        className: classSliderMarkTextNames,
        style: {
          left: index === 0 ? '0' : index === scale.length - 1 && item.toString().length > 0 ? lastOptionLength : index / (scale.length - 1) * 100 + '%'
        }
      }, item));
    });
    return results;
  };
  var renderRangeText = function renderRangeText() {
    var results = [];
    var classSliderMarkTextNames = ClassNames("ap-slider-mark-text ap-slider-range-text");
    results.push([/*#__PURE__*/React.createElement("span", {
      key: 0,
      "aria-hidden": true,
      className: classSliderMarkTextNames,
      style: {
        left: 0
      }
    }, min), /*#__PURE__*/React.createElement("span", {
      key: 1,
      "aria-hidden": true,
      className: classSliderMarkTextNames,
      style: {
        right: 0,
        marginRight: -16
      }
    }, max)]);
    return results;
  };
  var classHandleContainer = ClassNames("ap-slider-handle-container", {
    "has-interval-tick": hasInterval && showIntervalTick
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id || sliderId,
    className: classSliderNames,
    style: style,
    onMouseDown: function onMouseDown(e) {
      onBarClick(e);
    },
    ref: mergeRefs(ref, sliderRef)
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-slider-rail"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ap-slider-track",
    style: getTrackStyle()
  }), /*#__PURE__*/React.createElement("div", {
    className: "ap-slider-tick-container"
  }, hasInterval && showIntervalTick && renderSliderMarkTick()), /*#__PURE__*/React.createElement("div", {
    className: classHandleContainer
  }, renderSliderHandles()), /*#__PURE__*/React.createElement("div", {
    className: "ap-slider-mark"
  }, hasInterval && showIntervalLabel ? renderSliderMarkText() : showRange ? renderRangeText() : undefined));
});
export default Slider;